module.exports = __webpack_public_path__ + "static/media/alerta.fe0428f3.wav";